const changeAutomaticEmailsStr = {
  toastr: 'Dado alterado'
};

export default changeAutomaticEmailsStr;
